import { Button } from '@workingclock/ui';
import { useTranslation } from 'react-i18next';

import { signupUrl } from '../../lib/env';
import { Container } from '../layout/container';

export function FinalCtaSection() {
  const { t } = useTranslation('marketing');

  return (
    <section className="bg-ink py-20 md:py-28">
      <Container className="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
        <div>
          <h2 className="text-display text-bg">{t('home.finalCta.heading')}</h2>
          <p className="mt-3 max-w-lg text-body text-bg/70">{t('home.finalCta.body')}</p>
        </div>
        <Button size="lg" asChild className="shrink-0">
          <a href={signupUrl}>{t('home.finalCta.cta')}</a>
        </Button>
      </Container>
    </section>
  );
}
